<template>
    <ModelCheckbox
        class="acknowledgment"
        label="Я это знаю"
        :input-value="item.userAcknowledgment"
        @change="change"
        size="large"
        :disabled="loading"
    />
</template>

<script>
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import {mapActions} from 'vuex';

const actions = [
    'setCompetenceAcknowledge',
];

export default {
    components: {ModelCheckbox},
    data: () => ({
        loading: false,
    }),
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        ...mapActions('accountCompetences', actions),
        async change(v) {
            this.loading = true;
            await this.setCompetenceAcknowledge({
                competenceId: this.item.id,
                status: v,
            });
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';
    @import '~@/styles/mrem';
</style>